import React from 'react';
import styled from 'styled-components';
import { Paper } from '@mui/material';
import { useScroller } from '~/shared/services/charts';

const ScrollWrap = styled.div`
  flex: 1;
  overflow-y: scroll;
  height: 100%;
  max-width: 100%;
  padding-top: 5px;
`;

const MainContainer = styled(Paper)`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  iframe {
    border: none;
    color: var(--iframe-color);
    margin: 0;
    background-color: var(--iframe-background-color);
  }
`;

export default function IframePage({ url }: any) {
  const { scrollerRef } = useScroller();

  return (
    <ScrollWrap ref={scrollerRef}>
      <MainContainer>
        <iframe title="ms" width={window.innerWidth - 259} height={window.innerHeight - 64} src={url}></iframe>
      </MainContainer>
    </ScrollWrap>
  );
}
